// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","lists":"Footer_lists__1U-XU","links":"Footer_links__wMgLO"};